export { default as LabelRenderer } from './LabelRenderer.vue';

import { entry as labelRendererEntry } from './LabelRenderer.vue';

export const labelRenderers = [labelRendererEntry];
